/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AccountNav_user$ref = any;
type CartNav_user$ref = any;
type Notifications_user$ref = any;
type Rewards_user$ref = any;
export type TopBar_user$ref = any;
export type TopBar_user = {
    readonly " $fragmentRefs": AccountNav_user$ref & Rewards_user$ref & CartNav_user$ref & Notifications_user$ref;
    readonly " $refType": TopBar_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TopBar_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Rewards_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_user",
      "args": null
    }
  ]
};
(node as any).hash = '7158036a09c9d13c7164a311163039cb';
export default node;
